import { createFileRoute, Navigate } from '@tanstack/react-router'
import { Frontpage } from '../../modules/home/Frontpage'
import { useAuthStore } from '../../store/useAuthStore'

function HomePage() {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/" />
  }

  return <Frontpage />
}

export const Route = createFileRoute('/_app/home')({
  component: HomePage,
})
